import CryptoJS from 'crypto-js';

export const encrypt = (data, key) => {
  return CryptoJS.AES.encrypt(JSON.stringify(data), key).toString();
};

export const decrypt = (text, key) => {
  try {
    const bytes = CryptoJS.AES.decrypt(text, key);
    return JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
  } catch (error) {
    throw new Error('decrypt failed');
  }
};

export const getEncData = (data) => {
  if(typeof data === 'string'){
    return CryptoJS.AES.encrypt(data, process.env.ENC_KEY).toString();
  }
  else if(typeof data === 'object'){
    const rtnObj = {};

    Object.entries(data).map(([key, value]) => {
      return [key, CryptoJS.AES.encrypt(value, process.env.ENC_KEY).toString()];
    }).map(([key, value]) => {
      rtnObj[key] = value
    });

    return rtnObj;
  }
}

export const getDecData = (data) => {
  try{
    const bytes = CryptoJS.AES.decrypt(data, process.env.ENC_KEY);
    return bytes.toString(CryptoJS.enc.Utf8);
  }catch(error){
    throw new Error('decrypt failed');
  }
}